export const gitCommit = '97b8c834'
